// feature-flag.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';

interface AppConfig {
  betaUserEnabled: boolean;
}


@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  constructor(private http: HttpClient) {}

  getConfig(): Observable<any> {
    return this.http.get<any>('assets/betaFlagconfig.json');
  }
}
